import { Component, computed, inject } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { SessionService } from '../../session/session.service';

@Component({
  selector: 'sp-store-selection',
  imports: [MatFormFieldModule, MatSelectModule],
  templateUrl: './store-selection.component.html',
  styleUrl: './store-selection.component.scss'
})
export class StoreSelectionComponent {
  protected readonly sessionService = inject(SessionService);

  protected readonly store = computed(() => this.sessionService.store());
}
